import { ReactNode } from "react";
import { StyleProp, View, ViewStyle } from "react-native";
import { IconComponent } from "src/icons";
import { paddingMedium } from "src/styles/spacing";
import { Text } from "src/swsh-native";
import { GatheringViewerHorizontalPadding } from "../constants";

const SectionHeader = ({
	text,
	Icon,
	action,
	containerStyle,
}: {
	text: string;
	Icon: IconComponent;
	action?: ReactNode;
	containerStyle?: StyleProp<ViewStyle>;
}) => {
	return (
		<View
			style={[
				{
					flexDirection: "row",
					justifyContent: "space-between",
					paddingHorizontal: GatheringViewerHorizontalPadding,
				},
				containerStyle,
			]}
		>
			<View
				style={{
					flexDirection: "row",
					alignItems: "center",
					columnGap: paddingMedium,
				}}
			>
				{!!Icon && <Icon size={20} />}
				<Text semiLarge semibold>
					{text}
				</Text>
			</View>
			{action}
		</View>
	);
};
export default SectionHeader;
